/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfessionalBackground
 */
export interface ProfessionalBackground {
    /**
     * 
     * @type {string}
     * @memberof ProfessionalBackground
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalBackground
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalBackground
     */
    category: string;
}

/**
 * Check if a given object implements the ProfessionalBackground interface.
 */
export function instanceOfProfessionalBackground(value: object): value is ProfessionalBackground {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function ProfessionalBackgroundFromJSON(json: any): ProfessionalBackground {
    return ProfessionalBackgroundFromJSONTyped(json, false);
}

export function ProfessionalBackgroundFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfessionalBackground {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'category': json['category'],
    };
}

export function ProfessionalBackgroundToJSON(value?: ProfessionalBackground | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'category': value['category'],
    };
}

